import React from 'react'
import TextComponent from './TextComponent'
import DropdownComponent from './DropdownComponent'
import CheckboxComponent from './CheckboxComponent'
import CheckboxGroupComponent from './CheckboxGroupComponent'
import RadioComponent from './RadioComponent'
import CustomStatusComponent from './CustomStatusComponent'
import CustomLanguageComponent from './CustomLanguageComponent'
import TypeaheadComponent from './TypeaheadComponent'
import AsyncTypeaheadComponent from './AsyncTypeaheadComponent'
import MultiSelectComponent from './MultiSelectComponent'
import HiddenComponent from './HiddenComponent'
import ButtonComponent from './ButtonComponent'

class FieldComponent extends React.Component {
  fieldTypes = {
    'dropdown': DropdownComponent,
    'button': ButtonComponent,
    'radio' : RadioComponent,
    'hidden' : HiddenComponent,
    'checkbox': CheckboxComponent,
    'multiselect': MultiSelectComponent,
    'checkboxgroup': CheckboxGroupComponent,
    'custom:status': CustomStatusComponent,
    'custom:language': CustomLanguageComponent,
    'typeahead': TypeaheadComponent,
    'asynctypeahead': AsyncTypeaheadComponent,
    get: function(name, props){
      return props.showFilter ? (props.editMode ? this[name] : TextComponent) : this.hasOwnProperty(name) ? this[name] : TextComponent;
    }
  }

  render() {
    const Module = this.fieldTypes.get(this.props.type, this.props);
    return <Module {...this.props}/>;
  }

}

export default FieldComponent;



// WEBPACK FOOTER //
// ./src/components/common/FieldComponent.js